// extracted by mini-css-extract-plugin
export default {"customSocialMediaBtn":"CustomSocialMediaButton_customSocialMediaBtn__V4AZs","icon":"CustomSocialMediaButton_icon__pS+Mp","text":"CustomSocialMediaButton_text__fJXtB"};